module.exports = {
	"animals": [
		"aardvark",
		"alligator",
		"alpaca",
		"antelope",
		"ape",
		"armadillo",
		"baboon",
		"badger",
		"bat",
		"bear",
		"beaver",
		"bison",
		"boar",
		"buffalo",
		"bull",
		"camel",
		"canary",
		"capybara",
		"cat",
		"chameleon",
		"cheetah",
		"chimpanzee",
		"chinchilla",
		"chipmunk",
		"cougar",
		"cow",
		"coyote",
		"crocodile",
		"crow",
		"deer",
		"dingo",
		"dog",
		"donkey",
		"dromedary",
		"elephant",
		"elk",
		"ewe",
		"ferret",
		"finch",
		"fish",
		"fox",
		"frog",
		"gazelle",
		"gila monster",
		"giraffe",
		"gnu",
		"goat",
		"gopher",
		"gorilla",
		"grizzly bear",
		"ground hog",
		"guinea pig",
		"hamster",
		"hedgehog",
		"hippopotamus",
		"hog",
		"horse",
		"hyena",
		"ibex",
		"iguana",
		"impala",
		"jackal",
		"jaguar",
		"kangaroo",
		"koala",
		"lamb",
		"lemur",
		"leopard",
		"lion",
		"lizard",
		"llama",
		"lynx",
		"mandrill",
		"marmoset",
		"mink",
		"mole",
		"mongoose",
		"monkey",
		"moose",
		"mountain goat",
		"mouse",
		"mule",
		"muskrat",
		"mustang",
		"mynah bird",
		"newt",
		"ocelot",
		"opossum",
		"orangutan",
		"oryx",
		"otter",
		"ox",
		"panda",
		"panther",
		"parakeet",
		"parrot",
		"pig",
		"platypus",
		"polar bear",
		"porcupine",
		"porpoise",
		"prairie dog",
		"puma",
		"rabbit",
		"raccoon",
		"ram",
		"rat",
		"reindeer",
		"reptile",
		"rhinoceros",
		"salamander",
		"seal",
		"sheep",
		"shrew",
		"silver fox",
		"skunk",
		"sloth",
		"snake",
		"squirrel",
		"tapir",
		"tiger",
		"toad",
		"turtle",
		"walrus",
		"warthog",
		"weasel",
		"whale",
		"wildcat",
		"wolf",
		"wolverine",
		"wombat",
		"woodchuck",
		"yak",
		"zebra"
	]
};


/** WEBPACK FOOTER **
 ** ./corpora/data/animals/common.json
 **/